import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";
import SplitDescription from "../components/splitdescription";
import ServicesGridCards from "../components/servicesgrid";
import WhyTecloqCards from "../components/whytecloqcards";
import TransformComponent from "../components/transformcomp";

const servicesGridData = [
  {
    src: "/assets/AdvancedAI/TextAnalysis/intent.gif",
    alt: "Sentiment, Emotion & Intent Identifier",
    width: "58%",
    paddingTop: "3%",
    text: "Sentiment, Emotion<br />& Intent Identifier",
  },
  {
    src: "/assets/AdvancedAI/TextAnalysis/filefolder.webp",
    alt: "Categorization & Clustering",
    width: "65%",
    paddingTop: "0%",
    text: "Categorization &<br />Clustering",
  },
  {
    src: "/assets/AdvancedAI/TextAnalysis/chatbot.png",
    alt: "Natural Language Generation Chatbot",
    width: "50%",
    paddingTop: "10%",
    text: "Natural Language<br />Generation Chatbot",
  },
  {
    src: "/assets/AdvancedAI/TextAnalysis/dataextract.png",
    alt: "Structured Text Data Extraction",
    width: "50%",
    paddingTop: "8%",
    text: "Structured text<br />data extraction",
  },
  {
    src: "/assets/AdvancedAI/TextAnalysis/context.png",
    alt: "Context Aware Information Retrieval",
    width: "50%",
    paddingTop: "8%",
    text: "Context Aware<br />Information Retrieval",
  },
  {
    src: "/assets/AdvancedAI/TextAnalysis/summary.png",
    alt: "Summarization",
    width: "50%",
    paddingTop: "8%",
    text: "Summarization",
  },
];

const whyTecloqGrid = [
    {
      src: "/assets/AdvancedAI/DataScience/why1.gif",
      alt: "why1",
      title: "Industry Wide<br />Experience",
      description:
        "Tecloq is a Data Science & Analytics consulting firm that offers start-ups and Fortune 100 corporations world-class solutions, with an emphasis on ISV’s, media publishers, and retail service providers, since 2014.",
    },
    {
      src: "/assets/AdvancedAI/DataScience/why2.gif",
      alt: "why2",
      title: "Scalable<br />Applications",
      description:
        "Our machine learning algorithms and data mining approaches will aid in the development of scalable structures and machine learning pipelines in software and web applications for your business cases.",
    },
    {
      src: "/assets/AdvancedAI/DataScience/why3.gif",
      alt: "why3",
      title: "Skilled<br />Specialists",
      description:
        "Our data scientists are experts in their fields, with skills in predictive analytics, data pipelines, machine learning, and more, and can help you achieve your data science goals from beginning to end.",
    },
  ];

const AITextAnalysis = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflowX: "hidden" }}>
      <PageIntro
        bg={"/assets/AdvancedAI/TextAnalysis/background.webp"}
        subheading={"Making sense from Textual Data"}
        heading={"Text Analytics Services"}
        desc={
          "Analyzing text to empower you with insights that help your business grow"
        }
      />

      <SplitDescription
        heading1={"Uncover new Patterns, insights and Trends"}
        heading2={`Derive meaning from unstructured data`}
        content1={`Text analytics can help you uncover patterns and insights from
            unstructured text like emails, tweets, social media platforms,
            blogs, survey results, or online reviews to provide valuable
            insights about your customers. Moreover, by combining text analytics
            with advanced analytics and machine learning, you can predict the
            sentiment trend.`}
        content2={` At Tecloq, we derive meaning out of unstructured text data to help
            you gain new customer insight or determine sentiment about products
            and services. We follow a 360-degree approach that involves
            extracting and tokenizing the text, detecting term and sentence
            boundaries, tagging, parsing, and obtaining knowledge to derive
            insights.`}
        img1={"/assets/AdvancedAI/TextAnalysis/trends.webp"}
        img2={"/assets/AdvancedAI/TextAnalysis/data.webp"}
      />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "5%", sm: "4%", md: "3%" }, // Responsive margin
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", sm: "2.5%", md: "3%" }, // Responsive padding
            textAlign: "center", // Ensure proper alignment on small screens
          }}
        >
          Our Data Science Services & Solutions Offerings
        </Typography>
      </Box>

      <ServicesGridCards data={servicesGridData} />

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: "6%",
          paddingX: { xs: "5%", md: "0" }, // Add padding for smaller screens
        }}
      >
        {/* Title */}
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Adjust font size for mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
          }}
        >
          Why Tecloq?
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", md: "20px" }, // Adjust font size for mobile
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "3% 5%", md: "1% 15% 2% 15%" }, // Adjust margin for different screen sizes
            textAlign: "center",
          }}
        >
          Tecloq is a leading text analytics company in the US, offering
          cost-effective text analytics solutions to businesses of all sizes.
          Our custom text analytics services and solutions are designed to aid
          our clients in improving their customer experience through product
          integration. Our Text Analytics Services will help in the development
          of better products based on customer feedback, as well as the
          optimization of business operations.
        </Typography>
      </Box>

      <WhyTecloqCards data={whyTecloqGrid}/>
      
      <TransformComponent />
    </Box>
  );
};

export default AITextAnalysis;
